
import NavCards from '../blocks/nav-cards';
import OnlySmallsNavCards from '../blocks/only-smalls-nav-cards';

const templateServicesSingle = {
  init() {
    new OnlySmallsNavCards(".nav-card-block--only-smalls");
    new NavCards(".nav-card-block");
  }

}
export default templateServicesSingle;
